import { render, staticRenderFns } from "./InternationalCAPP-EN.vue?vue&type=template&id=a38b8e56&scoped=true"
import script from "./InternationalCAPP-EN.vue?vue&type=script&lang=js"
export * from "./InternationalCAPP-EN.vue?vue&type=script&lang=js"
import style0 from "./els-css/typography.gotham.css?vue&type=style&index=0&id=a38b8e56&prod&lang=css&scoped=true&external"
import style1 from "./InternationalCAPP-EN.vue?vue&type=style&index=1&id=a38b8e56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38b8e56",
  null
  
)

export default component.exports